import { render, staticRenderFns } from "./scorecard-clubspecific-orders.vue?vue&type=template&id=12835470&scoped=true"
import script from "./scorecard-clubspecific-orders.vue?vue&type=script&lang=js"
export * from "./scorecard-clubspecific-orders.vue?vue&type=script&lang=js"
import style0 from "./scorecard-clubspecific-orders.vue?vue&type=style&index=0&id=12835470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12835470",
  null
  
)

export default component.exports